import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Tag({
  tag = null,
  text = null,
  round = false,
  variant = "dark",
  tKey = "",
  icon = null,
}) {
  const { t } = useTranslation();
  if (!tag && !text) return null;
  return (
    <div>
      <span className={`tag tag-${variant} ${round ? "tag-round" : ""}`}>
        {icon && <FontAwesomeIcon icon={icon} className="mr-1" />}
        {t(`${tKey}${tag ? tag.label : text}`)}
      </span>
    </div>
  );
}

export default Tag;
